window.addEventListener('ig:sticky-offer', () => {
    const experiment = window.igData.user.getTestGroup('6835c86c-a34d-4921-8819-f8d71ab485ea')
    const isControl = experiment?.isControl

    if (experiment && !!!isControl) initStickyOffer()
})

function initStickyOffer() {
    const stickyOfferContainer = document.querySelector('.dtc-advertorial-sticky-offer');
    const firstFoldContainer = document.querySelector('.blog-content__container');

    if (!!!stickyOfferContainer || !!!firstFoldContainer) return

    window.addEventListener('scroll', () => {
        if ( 
            (isVisibleInViewport(firstFoldContainer) || firstFoldContainer.getBoundingClientRect().top < 0) 
            && window.scrollY > 0 // DON'T SHOW IF I'M IN TOP
            && (window.scrollY + window.innerHeight) < document.documentElement.offsetHeight) // DON'T SHOW IF I'M IN BOTTOM
          {
            stickyOfferContainer.classList.add('is-active')

            return
          }

        stickyOfferContainer.classList.remove('is-active')
    });
}

const isVisibleInViewport = (element) => {
    const rect = element.getBoundingClientRect()
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
}